import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaTiktok, FaSnapchat } from 'react-icons/fa';
import { useToast } from '../contexts/ToastContext';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const isAuthenticated = () => {
    return localStorage.getItem('authToken') !== null;
  };

  const handleProfileLink = (path) => {
    if (!isAuthenticated()) {
      showToast('Please login to access this feature.', 'info', { actionLabel: 'Login', actionTo: '/login' });
      navigate('/login');
      return;
    }
    
    // Special handling for wishlist - navigate directly without parameters
    if (path === '/wishlist') {
      navigate('/wishlist');
      return;
    }
    
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/images/logo.png" alt="Byeilir" className="footer-logo-img" />
            </div>
            <p className="footer-description">
              Your premier destination for quality products in the UAE. 
              We bring you the best selection with exceptional service.
            </p>
            <div className="social-links">
              <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                <FaInstagram />
              </a>
              <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                <FaTiktok />
              </a>
              <a href="https://www.instagram.com/by.eilir/?igsh=b2l4aHh5Z2JwYmJn#" className="social-link">
                <FaSnapchat />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">Home</Link>
              </li>
              <li>
                <Link to="/products" className="footer-link">Products</Link>
              </li>
              <li>
                <Link to="/categories" className="footer-link">Categories</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact Us</Link>
              </li>
              <li>
                <Link to="/refund-policy" className="footer-link">Refund Policy</Link>
              </li>
            </ul>
          </div>

          {/* My Profile */}
          <div className="footer-section">
            <h4 className="footer-subtitle">My Profile</h4>
            <ul className="footer-links">
              <li>
                <button 
                  onClick={() => handleProfileLink('/account')} 
                  className="footer-link-btn"
                >
                  My Account
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleProfileLink('/my-orders')} 
                  className="footer-link-btn"
                >
                  My Orders
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleProfileLink('/wishlist')} 
                  className="footer-link-btn"
                >
                  My Wishlist
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Dubai, United Arab Emirates</span>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span> 0501231234</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>info@byeilir.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>
              &copy; By Eilir All Rights Reserved | Powered By{' '}
              <a 
                href="https://ainsoftsolutions.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ainsoft-link"
              >
                Ainsoft Solutions
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
